module.exports = __webpack_public_path__ + "media/partners/norauto-8ebb5cf7.png";